import React from 'react'
import { Routes, Route } from 'react-router-dom'
import NavBar from './components/NavBar'
import Farmers from './pages/Farmers'
import MilkRecords from './pages/MilkRecords'
import Interests from './pages/Interests'
import Login from './pages/Login'
import ChangePassword from './pages/ChangePassword'
import ProtectedRoute from './components/ProtectedRoute'
import NagadAmount from './pages/NagadAmount'
import FarmerLedger from './pages/FarmerLedger'
import OldAmount from './pages/OldAmount'

export default function App(){
  return (
    <div>
      <NavBar />
      <main className="container">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/profile/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path="/" element={<ProtectedRoute><Farmers /></ProtectedRoute>} />
          <Route path="/milkrecs" element={<ProtectedRoute><MilkRecords /></ProtectedRoute>} />
          <Route path="/interests" element={<ProtectedRoute><Interests /></ProtectedRoute>} />
          <Route path="/nagadamount" element={<ProtectedRoute><NagadAmount /></ProtectedRoute>} />
          <Route path="/farmerledger" element={<ProtectedRoute><FarmerLedger /></ProtectedRoute>} />
          <Route path="/oldamount" element={<ProtectedRoute><OldAmount /></ProtectedRoute>} />
        </Routes>
      </main>
    </div>
  )
}
